import { Directive, Output, EventEmitter, HostListener } from '@angular/core';

@Directive({
    selector: '[enterDirective]',
    standalone: false
})
export class EnterDirective {
    @Output() enterPressed: EventEmitter<boolean> = new EventEmitter<false>();

    @HostListener('document: keydown.enter', ['$event'])
    onEnter(event: KeyboardEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.enterPressed.emit(true);
    }
}
